import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { TDataRow, TEventsList } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetAdminEvents = async ({
  supervisorId,
  adminId,
  dateMin,
  dateMax,
  type,
  subscription,
  gender,
  actionTaken,
  limit
}: {
  supervisorId: number;
  adminId: number;
  dateMin: Date;
  dateMax: Date;
  type: string;
  subscription: string;
  gender: string;
  actionTaken: string;
  limit: number;
}): Promise<{
  data: {
    eventsList: TEventsList;
    eventsCount: TDataRow[];
    totalEvents: number;
    auditEventID: number;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    adminEvents: {
      eventsList: TEventsList;
      eventsCount: TDataRow[];
      totalEvents: number;
      auditEventID: number;
    };
  }>(`auditor/getAdminEvents`, {
    supervisorId,
    adminId,
    dateMinObject: getDateAsObject(dateMin),
    dateMaxObject: getDateAsObject(dateMax),
    type,
    subscription,
    gender,
    actionTaken,
    limit
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data.adminEvents,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        eventsList: [],
        eventsCount: [],
        totalEvents: 0,
        auditEventID: 0
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        eventsList: [],
        eventsCount: [],
        totalEvents: 0,
        auditEventID: 0
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
